import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';

export default function Blog() {
  return (
    <section className="section page-section">
      <div className="section-header">
        <h1>Blog e ideas para XV años</h1>
        <p>Consejos, tendencias y guías para planear la fiesta perfecta.</p>
      </div>
      <div className="blog-grid">
        {blogPosts.map((post) => (
          <Link to={`/blog/${post.slug}`} className="blog-card" key={post.slug}>
            <img src={post.image} alt={post.title} loading="lazy" />
            <div className="blog-card-body">
              <span className="blog-category">{post.category}</span>
              <h3>{post.title}</h3>
              <p>{post.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
